import { formDataType, FormFieldType } from "./OfficeProfileData";

export const formDataInitialState: formDataType[] = [
  {
    id: "companyName",
    value: "",
    title: "Company Name",
    placeholder: "Please provide company name",
    required: true,
    errorMessage: "Please provide company name",
    valid: false,
    type: FormFieldType.TextInput,
  },
  {
    id: "officeAddress",
    value: "",
    title: "Office Address",
    placeholder: "Please provide address",
    required: true,
    errorMessage: "Please provide valid office address",
    valid: false,
    type: FormFieldType.Places,
  },

  {
    id: "hstNumber",
    value: "",
    title: "HST #",
    placeholder: "Please provide HST number",
    required: false,
    errorMessage: "Please provide a valid HST #",
    valid: true,
    type: FormFieldType.HST,
  },
  {
    id: "wsibNumber",
    value: "",
    title: "WSIB Billing Number",
    placeholder: "Please provide WSIB billing number",
    required: false,
    errorMessage: "Please provide valid WSIB billing number",
    valid: false,
    type: FormFieldType.Number,
  },
];
